import gql from 'graphql-tag';

const query = gql`
  query dailyMotivation($date: Date) {
    dailyMotivation {
      dailyMotivationQuote(date: $date) {
        ... on DailyMotivationQuote {
          quote
          author
          background {
            url
          }
        }
        ... on Error {
          code
          name
          description
        }
      }
    }
  }
`;

export default query;
